const readCourseNumber = (payload = {}) =>
  Number(payload?.courseNumber ?? payload?.course_number ?? 1);

export const hasExplicitCourse = (payload = {}) =>
  Boolean(payload?.courseId ?? payload?.course_id);

export const buildRhodeItemsSummary = (items = [], limit = 3) => {
  if (!Array.isArray(items) || items.length === 0) return "";
  const safeLimit = Math.max(1, Number(limit) || 3);
  const sample = items
    .slice(0, safeLimit)
    .map(
      (item) =>
        `${Math.max(1, Number(item?.quantity) || 1)} ${item?.name || "article"}`,
    )
    .join(", ");
  const remaining = items.length - safeLimit;
  return remaining > 0
    ? `${sample}, et ${remaining} ${
        remaining > 1 ? "autres articles" : "autre article"
      }`
    : sample;
};

export const buildSuiteTakeoverAnnouncement = (payload = {}) => {
  const courseNumber = readCourseNumber(payload);
  if (!Number.isInteger(courseNumber) || courseNumber <= 1 || payload?.isDelivery) {
    return "";
  }
  const articleCount = (payload?.items || []).reduce(
    (sum, item) => sum + Math.max(1, Number(item?.quantity) || 1),
    0,
  );
  const tableLabel = payload?.tableNumber || payload?.table || "inconnue";
  return `Suite table ${tableLabel}, tour ${courseNumber}. ${articleCount} ${
    articleCount > 1 ? "articles" : "article"
  } à prendre en charge.`;
};

export const buildSuiteReminderAnnouncement = (payload = {}) => {
  const courseNumber = readCourseNumber(payload);
  if (!Number.isInteger(courseNumber) || courseNumber <= 1 || payload?.isDelivery) {
    return "";
  }
  const tableLabel = payload?.tableNumber || payload?.table || "inconnue";
  return `Rappel. Le tour ${courseNumber} de la table ${tableLabel} attend toujours sa prise en charge.`;
};

export const buildUpcomingItemsAnnouncement = (payload = {}) => {
  const itemCount = Math.max(0, Number(payload?.upcomingItemCount) || 0);
  if (itemCount === 0 || payload?.isDelivery) return "";
  const courseCount = Math.max(0, Number(payload?.upcomingCourseCount) || 0);
  const courseSuffix =
    courseCount > 0
      ? ` dans ${courseCount} ${courseCount > 1 ? "tours" : "tour"}`
      : "";
  return `${itemCount} ${itemCount > 1 ? "articles restent" : "article reste"} à suivre${courseSuffix}.`;
};
